// Plans action types

const plansActionTypes = {
  SET_PLANS_AVAILABILITY_DETAILS_ERROR: 'SET_PLANS_AVAILABILITY_DETAILS_ERROR',
  GET_PLANS_AVAILABILITY_INFO_SUCCESS: 'GET_PLANS_AVAILABILITY_INFO_SUCCESS',
  GET_PLANS_AVAILABILITY_INFO_ERROR: 'GET_PLANS_AVAILABILITY_INFO_ERROR',
  GET_PLANS_AVAILABILITY_INFO_LOADING: 'GET_PLANS_AVAILABILITY_INFO_LOADING',
  SET_PLANS_IS_ERROR_MODAL_ALREADY_CLOSED: 'SET_PLANS_IS_ERROR_MODAL_ALREADY_CLOSED',
  GET_PLANS_RECENT_SEARCHES_INFO_SUCCESS: 'GET_PLANS_RECENT_SEARCHES_INFO_SUCCESS',
  GET_PLANS_RECENT_SEARCHES_INFO_LOADING: 'GET_PLANS_RECENT_SEARCHES_INFO_LOADING',
  GET_PLANS_RECENT_SEARCHES_INFO_ERROR: 'GET_PLANS_RECENT_SEARCHES_INFO_ERROR',
  DEL_PLANS_RECENT_SEARCHES_LOADING: 'DEL_PLANS_RECENT_SEARCHES_LOADING',
  DEL_PLANS_RECENT_SEARCHES_SUCCESS: 'DEL_PLANS_RECENT_SEARCHES_SUCCESS',
  DEL_PLANS_RECENT_SEARCHES_ERROR: 'DEL_PLANS_RECENT_SEARCHES_ERROR',
  SELECT_PLANS_SUITE_FOR_RANGE_TYPE: 'SELECT_PLANS_SUITE_FOR_RANGE_TYPE',
  OPEN_PLANS_RATES_CALENDAR: 'OPEN_PLANS_RATES_CALENDAR',
  CLOSE_PLANS_RATES_CALENDAR: 'CLOSE_PLANS_RATES_CALENDAR',
  CLEAN_PLANS_CALENDAR_RATES_BY_STAY: 'CLEAN_PLANS_CALENDAR_RATES_BY_STAY',
  LAST_PLANS_CALENDAR_RATES_BY_STAY_SELECTION: 'LAST_PLANS_CALENDAR_RATES_BY_STAY_SELECTION',
  OPEN_PLANS_CALENDAR_RATES_BY_STAY: 'OPEN_PLANS_CALENDAR_RATES_BY_STAY',
  OPEN_PLANS_RATES_CALENDAR_RESTRICTION: 'OPEN_PLANS_RATES_CALENDAR_RESTRICTION',
  OPEN_PLANS_RATES_CALENDAR_RESTRICTION_INCREMENT: 'OPEN_PLANS_RATES_CALENDAR_RESTRICTION_INCREMENT',
  GET_PLANS_LOWEST_RATES_CALENDAR: 'GET_PLANS_LOWEST_RATES_CALENDAR',
  GET_PLANS_LOWEST_RATES_CALENDAR_MOBILE: 'GET_PLANS_LOWEST_RATES_CALENDAR_MOBILE',
  CLEAN_PLANS_CALENDAR_RESTRICTIONS_AND_LOWEST_RATES: 'CLEAN_PLANS_CALENDAR_RESTRICTIONS_AND_LOWEST_RATES',
  GET_PLANS_AVAILABILITY_HIGHEST_RATES_SUCCESS: 'GET_PLANS_AVAILABILITY_HIGHEST_RATES_SUCCESS',
  GET_PLANS_AVAILABILITY_HIGHEST_RATES_ERROR: 'GET_PLANS_AVAILABILITY_HIGHEST_RATES_ERROR',
  GET_PLANS_AVAILABILITY_HIGHEST_RATES_DATES_EXCEEDED_ERROR:
    'GET_PLANS_AVAILABILITY_HIGHEST_RATES_DATES_EXCEEDED_ERROR',
  CLEAR_PLANS_ALL_HIGHEST_RATES_ERRORS: 'CLEAR_PLANS_ALL__HIGHEST_RATES_ERRORS',
  SET_PLANS_APPLIED_FILTERS: 'SET_PLANS_APPLIED_FILTERS',
  SET_PLANS_SELECTED_SUITE_NAME_FOR_CALENDAR: 'SET_PLANS_SELECTED_SUITE_NAME_FOR_CALENDAR',
  GET_PLANS_AVAILABILITY_RANGE_BY_SUITE_LOADING: 'GET_PLANS_AVAILABILITY_RANGE_BY_SUITE_LOADING',
  GET_PLANS_AVAILABILITY_RANGE_BY_SUITE_SUCCESS: 'GET_PLANS_AVAILABILITY_RANGE_BY_SUITE_SUCCESS',
  GET_PLANS_AVAILABILITY_RANGE_BY_SUITE_ERROR: 'GET_PLANS_AVAILABILITY_RANGE_BY_SUITE_ERROR',
  GET_PLANS_AVAILABILITY_RANGE_BY_SUITE_RESET: 'GET_PLANS_AVAILABILITY_RANGE_BY_SUITE_RESET',
  TOGGLE_PLANS_EMAIL_CAMPAIGNS: 'TOGGLE_PLANS_EMAIL_CAMPAIGNS',
  CLEAR_PLANS_ALL_AVAILABILITY_DATA: 'CLEAR_PLANS_ALL_AVAILABILITY_DATA',
  SET_PLANS_QUALIFYING_ID: 'SET_PLANS_QUALIFYING_ID',
  GET_PLANS_QUALIFYING_ID_HAS_ERROR: 'GET_PLANS_QUALIFYING_ID_HAS_ERROR',
  SET_PLANS_IS_BOOKING_WIDGET_FOCUSED: 'SET_PLANS_IS_BOOKING_WIDGET_FOCUSED',
  SET_PLANS_SORTING_ORDER: 'SET_PLANS_SORTING_ORDER',
  SET_PLANS_SUITE_CODE_FILTER: 'SET_PLANS_SUITE_CODE_FILTER',
  SET_PLANS_IS_CART_OPEN_CLOSE: 'SET_PLANS_IS_CART_OPEN_CLOSE',
  SET_PLANS_IS_CART_OPEN_CLOSE_CLEAN: 'SET_PLANS_IS_CART_OPEN_CLOSE_CLEAN',
  SET_PLANS_CART_RETURNED_PAGE_LINK_CLICKED: 'SET_PLANS_CART_RETURNED_PAGE_LINK_CLICKED',
  SET_PLANS_CART_RETURNED_PAGE_LINK_CLICKED_CLEAN: 'SET_PLANS_CART_RETURNED_PAGE_LINK_CLICKED_CLEAN',
  SET_PLANS_UPSELL_RECOMMENDATION_DATA: 'SET_PLANS_UPSELL_RECOMMENDATION_DATA',
  SET_PLANS_SAVE_POINTS_FOR_LATER: 'SET_PLANS_SAVE_POINTS_FOR_LATER',
  SET_PLANS_CHANGED_TO_FLEXIBLE: 'SET_PLANS_CHANGED_TO_FLEXIBLE'
};

export default plansActionTypes;
